<template>
  <v-card v-if="event" color="purple darken-2" dark class="elevation-4 mb-4">
    <v-card-title class="text-h5 font-weight-bold white--text">
      <v-icon large left>mdi-silverware-variant</v-icon>
      MUONITUS
    </v-card-title>
    <v-card-text class="white--text">
      <div class="text-h5 mb-2">
        {{ event.description }}
      </div>
      <div class="text-h6 mb-2">{{ eventFormattedDate }}</div>
      <div class="subtitle-1" v-if="event.headCountEstimate">
        Arvioitu henkilömäärä: {{ event.headCountEstimate }}
      </div>
      <div v-if="event.status" class="mt-2">
        Tila: {{ getStatusText(event.status) }}
      </div>
      <div class="mt-4 d-flex flex-wrap align-center">
        <v-btn text outlined color="white" class="mr-2 mb-2" @click="openEvent">
          Avaa tiedot <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
        <v-btn
          color="white"
          light
          rounded
          class="mb-2 font-weight-bold"
          :to="`/kauppalista/${event.id}`"
        >
          <v-icon left color="purple darken-2">mdi-cart</v-icon>
          Kauppalista
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { firestore as db } from "@/plugins/firebase.app";
import {
  collection,
  query,
  where,
  orderBy,
  getDocs,
  Timestamp,
} from "firebase/firestore";
import dayjs from "dayjs";

export default {
  name: "MuonitusInfo",
  data() {
    return {
      event: null,
      intervalId: null,
    };
  },
  computed: {
    eventFormattedDate() {
      if (!this.event || !this.event.date) return "";
      return dayjs(this.event.date.toDate()).format("dd DD.MM.YYYY HH:mm");
    },
  },
  methods: {
    async checkActiveMuonitus() {
      try {
        const now = dayjs();
        const start = Timestamp.fromDate(now.subtract(8, "hour").toDate());
        const end = Timestamp.fromDate(now.add(8, "hour").toDate());

        // Firestore query: catered events within +/- 8 hours
        const cateringsRef = collection(db, "caterings");
        const q = query(
          cateringsRef,
          where("date", ">=", start),
          where("date", "<=", end),
        );

        const querySnapshot = await getDocs(q);
        const events = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        if (events.length === 0) {
          this.event = null;
          return;
        }

        // Find the closest event to now
        let closest = null;
        let minDiff = Infinity;

        events.forEach((e) => {
          if (!e.date) return;
          const eDate = dayjs(e.date.toDate());
          const diff = Math.abs(now.diff(eDate));
          if (diff < minDiff) {
            minDiff = diff;
            closest = e;
          }
        });

        this.event = closest;
      } catch (e) {
        console.error("Failed to check active muonitus", e);
      }
    },
    openEvent() {
      if (this.event) {
        this.$router.push(`/muonitus/${this.event.id}`);
      }
    },
    getStatusText(status) {
      const texts = {
        planned: "Suunnitteilla",
        shopping: "Ostoksilla / Valmistuksessa",
        delivered: "Toimitettu maastoon",
        done: "Valmis / Purettu",
        billed: "Laskutettu",
      };
      return texts[status] || status;
    },
  },
  mounted() {
    this.checkActiveMuonitus();
    this.intervalId = setInterval(this.checkActiveMuonitus, 60000);
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  },
};
</script>
